// Root-relative URL base for the current Connect page.
//
// "" on a real agent subdomain (production), "/_connect/:slug" in path-preview
// mode — QA/dev serving Connect pages off the main app domain without wildcard
// DNS (see Middleware::ConnectPathPreview). The connect layout exposes it via
// <meta name="connect-base">; connect.js also installs a fetch wrapper from it
// so root-relative same-origin fetches transparently carry the prefix.
//
// Use connectPath() for URLs that do NOT go through fetch (hrefs built in JS,
// window.location.assign targets).

let cached = null;
let cachedPreview = null;

export function connectBase() {
  if (cached === null) {
    cached = document.querySelector('meta[name="connect-base"]')?.getAttribute("content") || "";
  }
  return cached;
}

// True inside the agent-facing editor preview (and template thumbnails), which
// reuse this layout but are served from the CRM host — where the consumer-only
// routes (/_track, /account/session) live behind the Connect subdomain
// constraint and so resolve to the SPA catch-all. Callers use this to skip
// those requests rather than firing 404s into the agent's console on every
// preview refresh. Emitted by the layout as <meta name="connect-preview">.
export function connectPreview() {
  if (cachedPreview === null) {
    cachedPreview = document.querySelector('meta[name="connect-preview"]') !== null;
  }
  return cachedPreview;
}

// Prefix a root-relative path with the page's base. Idempotent: an already
// prefixed path (or an absolute/anchor/protocol-relative URL) passes through.
export function connectPath(path) {
  const base = connectBase();
  if (!base) return path;
  if (typeof path !== "string" || !path.startsWith("/") || path.startsWith("//")) return path;
  if (path === base || path.startsWith(`${base}/`)) return path;
  return `${base}${path}`;
}

// A localStorage/sessionStorage key scope for the current Connect site. On a
// subdomain host the host alone is unique per agent; in path-preview mode every
// agent shares the dev host, so the base disambiguates them.
export function connectStorageScope() {
  return `${window.location.host}${connectBase()}`;
}
